module.exports = __webpack_public_path__ + "img/ISO45001_UKAS.2ae67c0d.png";